import reviewMutations from "./mutations.js";
import reviewActions from "./actions.js";
import reviewReportGetters from "./getters.js";

export default {
  namespaced: true,
  state() {
    return {

    };
  },
  mutations: reviewMutations,
  actions: reviewActions,
  getters: reviewReportGetters,
};
